import { chSupabase } from './supabase';
import type { ChUserRole } from '../types';

export interface ChAccessInfo {
  role: ChUserRole | null;
  isAgencyStaff: boolean;
  hasAccess: boolean;
}

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(payload);
  } catch {
    return null;
  }
}

export async function resolveChAccess(): Promise<ChAccessInfo> {
  const { data: { session } } = await chSupabase.auth.getSession();
  if (!session) return { role: null, isAgencyStaff: false, hasAccess: false };

  const claims = decodeJwtPayload(session.access_token);

  if (claims && typeof claims.ch_role === 'string') {
    const role = claims.ch_role as ChUserRole;
    const isAgencyStaff = claims.is_agency_staff === true;
    return { role, isAgencyStaff, hasAccess: true };
  }

  const { data, error } = await chSupabase
    .from('ch_profiles')
    .select('role')
    .eq('id', session.user.id)
    .maybeSingle();

  if (error || !data) return { role: null, isAgencyStaff: false, hasAccess: false };

  const role = data.role as ChUserRole;
  const isAgencyStaff = role === 'admin' || role === 'project_manager';
  return { role, isAgencyStaff, hasAccess: true };
}
